module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-form', [_c('v-card', {
    staticClass: "grey lighten-4",
    attrs: {
      "flat": ""
    }
  }, [_c('request-status', {
    attrs: {
      "request": _vm.paymentRequest
    }
  }), _vm._v(" "), (_vm.isSuccess) ? _c('v-card-text', {
    staticClass: "text-center",
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('v-badge', {
    attrs: {
      "overlap": ""
    },
    scopedSlots: _vm._u([{
      key: "badge",
      fn: function() {
        return [_c('v-icon', {
          attrs: {
            "dark": ""
          }
        }, [_vm._v("check_circle")])]
      },
      proxy: true
    }], null, false, 2123438404)
  }, [_vm._v(" "), _c('v-icon', {
    staticClass: "pt-2",
    attrs: {
      "size": 72,
      "color": "green"
    }
  }, [_vm._v("paid")])], 1), _vm._v(" "), _c('h3', {
    staticClass: "subheading"
  }, [_vm._v("\n          Payment tracked")]), _vm._v(" "), (_vm.totalDue > 0) ? _c('v-btn', {
    staticClass: "mb-0",
    attrs: {
      "disabled": _vm.statementLoading,
      "flat": ""
    },
    on: {
      "click": function($event) {
        return _vm.reset()
      }
    }
  }, [_vm._v("Add another payment")]) : _vm._e(), _c('br'), _vm._v(" "), _c('v-btn', {
    staticClass: "mt-0",
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.reset();
        _vm.$emit("close")
      }
    }
  }, [_vm._v("Done")])], 1) : _vm._e(), _vm._v(" "), [_c('v-card-text', [_c('read-only-statement-list', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.withAppointmentInfo),
      expression: "withAppointmentInfo"
    }],
    attrs: {
      "initially-collapsed": "",
      "appointment-ids": _vm.computedAppointmentIds,
      "relationships": _vm.relationships,
      "due": _vm.totalDue,
      "touch": _vm.statementTouch,
      "loading": _vm.statementLoading
    },
    on: {
      "update:relationships": function($event) {
        _vm.relationships = $event
      },
      "update:due": function($event) {
        _vm.totalDue = $event
      },
      "update:loading": function($event) {
        _vm.statementLoading = $event
      },
      "update:currency": _vm.setCurrency
    }
  }, [_c('template', {
    slot: "list-tile"
  }, [_c('v-list-tile-action', [_c('v-checkbox', {
    model: {
      value: (_vm.paidInFull),
      callback: function($$v) {
        _vm.paidInFull = $$v
      },
      expression: "paidInFull"
    }
  })], 1), _vm._v(" "), _c('v-list-tile-content', {
    on: {
      "click": function($event) {
        _vm.paidInFull = !_vm.paidInFull
      }
    }
  }, [_c('v-list-tile-title', [_vm._v("Paid in full")])], 1)], 1), _vm._v(" "), _c('v-progress-linear', {
    staticClass: "pa-0",
    attrs: {
      "slot": "list-end",
      "value": _vm.percentPaid,
      "height": "2"
    },
    slot: "list-end"
  })], 2), _vm._v(" "), (!_vm.isSuccess) ? [_c('v-flex', {
    staticClass: "mt-3",
    attrs: {
      "xs12": ""
    }
  }, [_c('v-dialog', {
    ref: "dialog",
    attrs: {
      "persistent": "",
      "lazy": "",
      "full-width": "",
      "width": "290px"
    },
    model: {
      value: (_vm.dialog),
      callback: function($$v) {
        _vm.dialog = $$v
      },
      expression: "dialog"
    }
  }, [_c('v-text-field', {
    attrs: {
      "slot": "activator",
      "persistent-hint": "",
      "hint": "The date on which you received this payment",
      "label": "Payment date",
      "prepend-icon": "event",
      "readonly": ""
    },
    slot: "activator",
    model: {
      value: (_vm.payment.date),
      callback: function($$v) {
        _vm.$set(_vm.payment, "date", $$v)
      },
      expression: "payment.date"
    }
  }), _vm._v(" "), _c('v-date-picker', {
    attrs: {
      "scrollable": "",
      "reactive": ""
    },
    model: {
      value: (_vm.payment.date),
      callback: function($$v) {
        _vm.$set(_vm.payment, "date", $$v)
      },
      expression: "payment.date"
    }
  }, [_c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.dialog = false
      }
    }
  }, [_vm._v("Cancel")])], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "disabled": _vm.paidInFull,
      "prefix": _vm.currency,
      "label": "Payment amount",
      "type": "number",
      "required": ""
    },
    model: {
      value: (_vm.payment.amount),
      callback: function($$v) {
        _vm.$set(_vm.payment, "amount", $$v)
      },
      expression: "payment.amount"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Reference",
      "hint": "(optional) - record a reference for this payment"
    },
    model: {
      value: (_vm.payment.reference),
      callback: function($$v) {
        _vm.$set(_vm.payment, "reference", $$v)
      },
      expression: "payment.reference"
    }
  })], 1), _vm._v(" "), [_c('v-subheader', {
    staticClass: "overline my-0 px-0"
  }, [_vm._v("Payment method")]), _vm._v(" "), _vm._l((_vm.paymentMethods), function(method) {
    return _c('v-chip', {
      key: method.value,
      staticClass: "mt-0",
      attrs: {
        "small": ""
      },
      on: {
        "click": function($event) {
          _vm.payment.payment_method = method.value
        }
      }
    }, [(_vm.payment.payment_method === method.value) ? _c('v-icon', {
      attrs: {
        "left": "",
        "small": ""
      }
    }, [_vm._v("check")]) : _vm._e(), _vm._v("\n              " + _vm._s(method.text) + "\n            ")], 1)
  })], _vm._v(" "), _c('v-alert', {
    attrs: {
      "type": "error",
      "value": _vm.paymentExceedsAppointments
    }
  }, [_c('strong', [_vm._v("Warning!")]), _vm._v("\n            You are about to add a payment larger than the value\n            of the appointments. You can do this .. but it might not be a good idea.\n          ")])] : _vm._e(), _vm._v(" "), (_vm.withActions && !_vm.isSuccess) ? [_c('v-divider', {
    staticClass: "mt-3"
  }), _vm._v(" "), _c('v-card-actions', {
    staticClass: "mb-5"
  }, [(_vm.totalDue && _vm.dueAfterPayment !== false) ? _c('span', [(_vm.dueAfterPayment > 0) ? _c('v-chip', [_c('strong', [_vm._v(_vm._s(_vm.formatCurrency(_vm.currency, _vm.dueAfterPayment)))]), _vm._v("   still owed to you\n              ")]) : _vm._e(), _vm._v(" "), (_vm.dueAfterPayment < 0) ? _c('v-chip', {
    attrs: {
      "outline": "",
      "color": "warning"
    }
  }, [_c('v-icon', [_vm._v("warning")]), _vm._v(" Payment amount higher than the value of these appointments\n              ")], 1) : _vm._e(), _vm._v(" "), (_vm.dueAfterPayment === 0) ? _c('v-chip', {
    attrs: {
      "color": "success",
      "dark": ""
    }
  }, [_c('v-icon', {
    attrs: {
      "left": ""
    }
  }, [_vm._v("check")]), _vm._v(" Paid in full\n              ")], 1) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('v-spacer'), _vm._v(" "), (_vm.isValid !== true) ? _c('span', {
    staticClass: "red--text caption"
  }, [_c('v-icon', {
    staticClass: "mr-1",
    attrs: {
      "color": "error",
      "small": ""
    }
  }, [_vm._v("warning")]), _vm._v("\n              " + _vm._s(_vm.isValid) + "\n            ")], 1) : _vm._e()], 1), _vm._v(" "), _c('v-card-actions', {
    class: _vm.mobileCardActionsClasses,
    style: (_vm.mobileCardActionsStyles)
  }, [(_vm.withDone) ? _c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        return _vm.$emit("close")
      }
    }
  }, [_vm._v("Cancel")]) : _vm._e(), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "disabled": _vm.isValid !== true,
      "loading": _vm.paymentRequest.loading,
      "color": "primary",
      "dark": ""
    },
    on: {
      "click": _vm.trackPayment
    }
  }, [_vm._v("Add payment")])], 1)] : _vm._e()], 2)]], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4a67e9de","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/appointment/actions/CreateTransaction.vue
// module id = 1416
// module chunks = 9